<template>
    <div class="myt-pattern">
        <div class="create-test-selectedSubject ">
            <v-btn
                class="left-btn cust-btn create-tst-btn"
                width="25%"
                color="primary"
                @click="openMYTPopup(false)"
                >Create Test</v-btn
            >
        </div>
        <v-row justify="center" class="mty-pattern-scroll" v-if="tabsList && tabsList.length > 0">
            <v-col
                cols="12"
                class="check-accordian-col"
                v-for="subject in tabsList"
                :key="subject.id"
            >
                <div
                    class="check-accordian check-accordian-header"
                    v-if="!subject.isOpen"
                >
                    <div class="check-accordian-check">
                        <v-checkbox
                            v-if="!subject.showIndexTopics"
                            v-model="subject.checked"
                            :value="subject.checked"
                            @click="onCheckedUnchecked(subject)"
                        ></v-checkbox>
                        <v-btn
                            v-else
                            @click="onCheckedUnchecked(item)"
                            type="button"
                            class="check-minus"
                            ><v-icon>mdi-minus</v-icon></v-btn
                        >
                        <div
                            class="check-accordian-text"
                            @click="onOpenChapters(subject)"
                        >
                            {{ subject.title }}
                        </div>
                        <div
                            class="check-accordian-down-arrow"
                            @click="onOpenChapters(subject)"
                        >
                            <v-icon>mdi-chevron-down</v-icon>
                        </div>
                    </div>
                </div>
                <div
                    class="check-accordian exp-accordian"
                    v-else-if="subject.isOpen"
                >
                    <div class="exp-accordian-header">
                        <div class="exp-accordian-check">
                            
                            <div
                                class="exp-accordian-text"
                                @click="onOpenChapters(subject)"
                            >
                                {{ subject.title }}
                            </div>
                            <div
                                class="check-accordian-down-arrow"
                                @click="onOpenChapters(subject)"
                            >
                                <v-icon>mdi-chevron-up</v-icon>
                            </div>
                        </div>
                    </div>
                    <div
                        class="accordian-row"
                        v-for="item in subject.chapters"
                        :key="item.id"
                    >
                        <div
                            class="check-accordian-check"
                            @click="onCheckedUnchecked(item)"
                        >
                            <v-checkbox
                                @click="onCheckedUnchecked(item)"
                                v-model="item.checked"
                                :value="item.checked"
                            ></v-checkbox>

                            <div class="sub-accordian-text">
                                {{ item.title }}
                            </div>
                        </div>
                    </div>
                </div>
            </v-col>
        </v-row>
        <AlertBox
            :width="modalwidth"
            :onClose="onCloseAlertBox"
            :component="cComponent"
            :status="open"
            :data="customErrorMsg"
        />
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import ChapterTopicList from "@/components/coordinator/Tests/CustomizedTests/ChapterTopicList.vue";

export default {
    name: "MYTPatternII",
    props: ["onBackClick", "data", "stepOneData", "stepTwoData"],
    components: {
        ChapterTopicList,
    },
    mounted() {
        this.tabsList = this.stepOneData.selectedSubjects;
        this.defaultData();
        this.checkSessionData();
        this.getSubjectChaptersAndTopics();
    },
    data() {
        return {
            tab: null,
            tabsList: [],
            tabId: null,
            subjects: [],
            panel: [0],
            sIndex: null,
            dataTreeLevel: { subjects: 2, chapter: 3, topic: 4 },

            selectedSubject: {
                id: 1,
                chapters: [
                    // { id:1,text: "", checked: false,showIndexTopics:false },
                ],
            },
            selectedChatersTopics: {},
            open: false,
            cComponent: null,
            modalwidth: "1000px",
            customErrorMsg: "",
        };
    },
    methods: {
        ...mapActions({
            getRefData: "utilStore/getRefData",
            getSubTypeList: "utilStore/getSubTypeList",
            setQuestions: "questionStore/setQuestions",
            setQuestionsTypeList: "questionStore/setQuestionsTypeList",
            getDataTree: "utilStore/getDataTree",
            createCustomTestAPI: "testStore/createCustomTest",
        }),
        defaultData() {
            let routeName = this.$route.name;
            // this.subjects = this.stepOneData.selectedSubjects;
            let crd = this.getCurrentRouteDetails(routeName);
            if (crd) {
                this.tab = this.tabsList[0].name;
            }
        },
        checkSessionData() {
            let rp = this.$route; // route params
            let crd = this.getCurrentRouteDetails(rp.name);

            if (rp.params.resetPage || !crd.routeName) {
                let tabDetail = {};
                this.tabsList.map((t) => {
                    tabDetail[t.name] = {
                        page: 1,
                        orderBy: {
                            field: "test_name",
                            order: "ASC",
                        },
                    };
                });
                let routeDetails = {
                    routeName: rp.name,
                    selectedTab: this.tab,
                    tabDetails: tabDetail,
                };
                this.setRouteDetails(routeDetails);
            }
        },
        onTabChange(tab) {
            this.tabId = tab;
            this.selectedSubject = tab;
        },

        getSubjectChaptersAndTopics() {
            let tabData = [],
                length = this.tabsList.length;
            let question_type = [];
            // this.stepTwoData.data.questions.map(q => {
            // 	if (!question_type.includes(q.questionType.id)) {
            // 		question_type.push(q.questionType.id)
            // 	}
            // })
            this.$root.showLoader = true;
            this.tabsList.map((t) => {
                let reqData = {
                    parentIds: this.getSubjectId(t),
                    question_type: "",          
                    sub_subject:this.checkBiology(t)? t.code : "",
                    target_exam: this.stepOneData.selectedTarget
                };
                this.getDataTree(reqData)
                    .then((response) => {
                        t = {
                            sort_by:t.sortBy,
                            ...response.tree,
                            title:t.title,
                            id:t.id
                        };

                        let chapters = [];
                        t.children.map((c) => {
                            if (c.is_add_btn === 0) {
                                // console.log(c);

                                let topics = [];

                                let h = {
                                    ...c,
                                    checked: false,
                                    showTopics: false,
                                    parent:t.id,
                                    showIndexTopics: false,
                                };
                                c.children && c.children.length > 0
                                    ? c.children.map((p) => {
                                          if (p.is_add_btn === 0) {
                                              let x = { ...p };
                                              x.checked = false;
                                              topics.push(x);
                                          }
                                      })
                                    : [],
                                    (h.topic = topics);
                                delete h.children;

                                chapters.push(h);
                            }
                        });
                        t.chapters = chapters;
                        delete t.children;
                        t.checked = false;
                        t.showIndexTopics = false;
                        t.isOpen = false;

                        this.selectedChatersTopics[t.title] = {
                            selectedChapters: [],
                            selectedSubject: [],
                        };

                        tabData.push(t);

                        if (tabData.length === length) {
                            this.$root.showLoader = false;
                            this.selectedSubject = tabData[0];
                        }
                    })
                    .catch((err) => {
                        this.$root.showLoader = false;
                    });
            });

            this.tabsList = tabData;
        },
        onCheckedUnchecked(item) {
            let sIndex = -1;
            if (item.level === this.dataTreeLevel.chapter) {
                sIndex = this.tabsList.findIndex((t) => t.id === item.parent);
            } else if (item.level === this.dataTreeLevel.subjects) {
                sIndex = this.tabsList.findIndex((t) => t.id == item.id);
            }
            this.sIndex = sIndex;
            if (item.checked) {
                if (item.level === this.dataTreeLevel.subjects) {
                    this.tabsList[sIndex].chapters.map(
                        (t) => (t.checked = true)
                    );
                    if (
                        !this.selectedChatersTopics[
                            this.tabsList[sIndex].title
                        ].selectedSubject.includes(item.id)
                    ) {
                        this.selectedChatersTopics[
                            this.tabsList[sIndex].title
                        ].selectedSubject.push(item.id);
                        this.tabsList[sIndex].chapters.map((t) => {
                            let i = this.selectedChatersTopics[
                                this.tabsList[sIndex].title
                            ].selectedChapters.indexOf(t.id);
                            if (i >= 0) {
                                this.selectedChatersTopics[
                                    this.tabsList[sIndex].title
                                ].selectedChapters.splice(i, 1);
                            }
                        });
                    }
                    this.tabsList[sIndex].chapters.map((t) => {
                        let i = this.selectedChatersTopics[
                            this.tabsList[sIndex].title
                        ].selectedChapters.indexOf(t.id);
                        if (
                            !this.selectedChatersTopics[
                                this.tabsList[sIndex].title
                            ].selectedChapters.includes(t.id)
                        ) {
                            this.selectedChatersTopics[
                                this.tabsList[sIndex].title
                            ].selectedChapters.push(t.id);
                        }
                    });
                } else if (item.level === this.dataTreeLevel.chapter) {
                    let index = this.tabsList[sIndex].chapters.findIndex(
                        (c) => c.id === item.id
                    );
                    if (
                        !this.selectedChatersTopics[
                            this.tabsList[sIndex].title
                        ].selectedChapters.includes(item.id)
                    ) {
                        this.selectedChatersTopics[
                            this.tabsList[sIndex].title
                        ].selectedChapters.push(item.id);
                        this.tabsList[sIndex].showIndexTopics = true;
                    }
                    const filteredSubjects = this.tabsList[
                        sIndex
                    ].chapters.filter((o) => o.checked === true);
                    let isChecked =
                        filteredSubjects.length ===
                        this.tabsList[sIndex].chapters.length;

                    if (isChecked) {
                        this.tabsList[sIndex].checked = true;
                        this.tabsList[sIndex].showIndexTopics = false;
                        this.tabsList[sIndex].chapters.map((t) => {
                            let i = this.selectedChatersTopics[
                                this.tabsList[sIndex].title
                            ].selectedChapters.indexOf(t.id);
                            if (i >= 0) {
                                this.selectedChatersTopics[
                                    this.tabsList[sIndex].title
                                ].selectedChapters.splice(i, 1);
                            }
                        });
                        if (
                            !this.selectedChatersTopics[
                                this.tabsList[sIndex].title
                            ].selectedSubject.includes(item.parent)
                        ) {
                            this.selectedChatersTopics[
                                this.tabsList[sIndex].title
                            ].selectedSubject.push(item.parent);
                        }
                    }
                }
            } else {
                if (item.level === this.dataTreeLevel.subjects) {
                    this.tabsList[sIndex].chapters.map((t) => {
                        t.checked = false;
                    });
                    this.tabsList[sIndex].showIndexTopics = false;
                    let i = this.selectedChatersTopics[
                        this.tabsList[sIndex].title
                    ].selectedSubject.indexOf(item.id);
                    this.selectedChatersTopics[
                        this.tabsList[sIndex].title
                    ].selectedSubject.splice(i, 1);
                } else if (item.level === this.dataTreeLevel.chapter) {
                    let index = this.tabsList[sIndex].chapters.findIndex(
                        (c) => c.id === item.id
                    );
                    //   let j = this.tabsList[sIndex].chapters[index].topic.findIndex(
                    //     (c) => c.id === item.id
                    //   );
                    let isChecked = this.tabsList[sIndex].chapters.some(
                        (t) => t.checked === false
                    );
                    this.tabsList[sIndex].chapters[index].checked = false;
                    if (!isChecked) {
                        this.tabsList[sIndex].checked = false;
                        this.tabsList[sIndex].showIndexTopics = true;
                    }
                    this.tabsList[sIndex].chapters.map((x) => {
                        if (
                            x.checked &&
                            !this.selectedChatersTopics[
                                this.tabsList[sIndex].title
                            ].selectedChapters.includes(x.id)
                        ) {
                            this.selectedChatersTopics[
                                this.tabsList[sIndex].title
                            ].selectedChapters.push(x.id);
                        } else if (
                            !x.checked &&
                            this.selectedChatersTopics[
                                this.tabsList[sIndex].title
                            ].selectedChapters.includes(x.id)
                        ) {
                            let i = this.selectedChatersTopics[
                                this.tabsList[sIndex].title
                            ].selectedChapters.indexOf(x.id);
                            if (i >= 0) {
                                this.selectedChatersTopics[
                                    this.tabsList[sIndex].title
                                ].selectedChapters.splice(i, 1);
                            }
                        }
                    });
                    let i = this.selectedChatersTopics[
                        this.tabsList[sIndex].title
                    ].selectedSubject.indexOf(item.parent);
                    if (i >= 0) {
                        this.selectedChatersTopics[
                            this.tabsList[sIndex].title
                        ].selectedSubject.splice(i, 1);
                    }

                    let found = this.tabsList[sIndex].chapters.some(
                        (t) => t.checked === true
                    );
                    if (!found) {
                        this.tabsList[sIndex].showIndexTopics = false;
                    }
                }
            }
            this.selectedSubject = this.tabsList[sIndex];
        },
        createCustomTest(confirmation = false) {
            this.$root.showLoader = true;

            let stepOneData = this.stepOneData;
            this.stepOneData.questions = this.stepOneData.questionList;
            // let questionTypes = this.stepTwoData.questionTypes;
            let { questions, optionalQuestionsList } = this.stepOneData;
            let {list,forUpdate} = this.createTestData({...this.stepOneData,selectedChatersTopics:this.selectedChatersTopics},confirmation,true)
            let reqData = {
                list: list,
                target_exam: stepOneData.selectedTarget,
                test_type: this.TEST_TYPE.MYT,
                duration: stepOneData.duration,
                test_name: stepOneData.testName,
                optionalQuestionsList: optionalQuestionsList,
                instructions: stepOneData.selectedPatterns.pattern_instruction,
                test_sub_type: this.TEST_SUB_TYPES.MYT,
                test_pattern: stepOneData.selectedPatterns.id,
            };
            if (forUpdate) {
                reqData.only_question = true;
            }
            if (stepOneData.testId) {
                reqData.id = stepOneData.testId;
            }
            this.createCustomTestAPI(reqData)
                .then((response) => {
                    let subjectCustomMsg = [];

                    if (response.code === 204) {
                        this.customErrorMsg = subjectCustomMsg;
                        this.cComponent =
                            "components/coordinator/Tests/CustomizedTests/MYTAlertBox";
                        this.modalwidth = "500px";
                        this.open = true;
                    } else {
                        this.$toasted.success(`Success\n${response.msg}`, {
                            icon: "check_circle",
                        });
                        if (forUpdate) {
                            this.onClose({
                                status: false,
                                reloadPreview: true,
                            });
                        } else {
                            this.$router.push({ name: "make-your-test" });
                        }
                    }
                    this.disableCreateTest = false;

                    this.$root.showLoader = false;
                })
                .catch((err) => {
                    this.$root.showLoader = false;
                });
        },
        onCloseAlertBox(data) {
            this.open = data.status;
            if (data.confirm) {
                this.createCustomTest(data.confirm);
            }
        },
        onOpenChapters(subject) {
            if (subject.isOpen) {
                let index = this.tabsList.findIndex(
                    (sub) => sub.id === subject.id
                );
                if (index >= 0) {
                    this.tabsList[index].isOpen = false;
                }
                return;
            } else {
                this.tabsList.map((subject) => {
                    subject.isOpen = false;
                });
                let index = this.tabsList.findIndex(
                    (sub) => sub.id === subject.id
                );
                if (index >= 0) {
                    this.tabsList[index].isOpen = true;
                }
            }
        },
        openMYTPopup() {
            this.cComponent =
                "components/coordinator/Tests/CustomizedTests/MYTConfirmationBox";
            this.modalwidth = "500px";
            this.open = true;
			this.customErrorMsg = {
				tabsList:this.tabsList,
				stepOneData:this.stepOneData
			}
        },
    },
    watch: {
        tab(val, oldVal) {
            if (oldVal) {
                // only when tab is changed and not on page load
                let routeName = this.$route.name;
                this.setRouteDetails({ routeName, selectedTab: val });
            }
        },
    },
};
</script>
